import { Component } from '@angular/core';
import * as fromRouter from '@app/root-store/router';
import { Store } from '@ngrx/store';
import { environment } from '@env/environment';
import * as fromUser from '@core/user/store';

@Component({
  selector: 'app-my-roche-banner',
  templateUrl: './my-roche-banner.component.html',
  styleUrls: ['./my-roche-banner.component.scss']
})
export class MyRocheBannerComponent {
  public allowToShow$ = this.store$.select(fromUser.selectAllowShowMyRochePage);
  goOutside() {
    this.store$.dispatch(fromRouter.goInNewTab({url: environment.myRocheLink, redirect:true}));
  }

  constructor(
    private store$: Store
  ) {
  }
}

